import React, { useEffect, useState } from "react";
import "../../styles/YoutubeFolder.css";
import icon from "../../assets/images/youtube.png";
import Draggable from "react-draggable";

const YoutubeFolder = ({ name, onClick }) => {
    const [isDesktop, setIsDesktop] = useState(true);
    const [clickCount, setClickCount] = useState(0);

    useEffect(() => {
        const checkDevice = () => {
            setIsDesktop(!("ontouchstart" in window || navigator.maxTouchPoints > 0));
        };
        checkDevice();
        window.addEventListener("resize", checkDevice);
        return () => window.removeEventListener("resize", checkDevice);
    }, []);

    const handleClick = () => {
        setClickCount((prevCount) => prevCount + 1);

        setTimeout(() => {
            setClickCount(0);
        }, 300); // Délai de double-clic standard

        if (clickCount === 1) {
            onClick(); // Ouvre le lien après un double-clic
        }
    };

    return isDesktop ? (
        <Draggable>
            <div className="youtube">
                <div onClick={handleClick}>
                    <img src={icon} alt="youtube icon" />
                    <span>{name}</span>
                </div>
            </div>
        </Draggable>
    ) : (
        <div className="youtube" onClick={onClick}>
            <img src={icon} alt="youtube icon" />
            <span>{name}</span>
        </div>
    );
};

export default YoutubeFolder;